import { Component, OnInit, ViewChild } from '@angular/core';
import { CustomStore, ArkUnitOfWork, BreezeDxStoreService, AppInformationService } from 'app/core/core.module';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
    selector: 'app-overview',
    templateUrl: './overview.component.html',
    styleUrls: ['./overview.component.scss'],
    standalone: false,
})
export class OverviewComponent implements OnInit {

    batches: CustomStore;
    offeringHistory: any;
    @ViewChild('overviewGrid') dataGrid: DxDataGridComponent;

    constructor(private uow: ArkUnitOfWork, private storeService: BreezeDxStoreService, public appInfo: AppInformationService) {}

    async ngOnInit() {
        // this.getStore();
        // this.offeringHistory = await this.uow.getOfferingHistory();
        // let i = 0;
        // this.offeringHistory.forEach((x) => {
            // x.date = moment(x.date).toDate();
            // i++;
        // });
        // console.log(this.offeringHistory);
    }

    getStore() {
        // const query = this.uow.contributionBatches.baseQuery().expand(['status']).orderByDesc('date');
        // this.batches = this.storeService.createStore(this.uow.contributionBatches, query, 'id', 'name');
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            template: 'toolbarButtons'
        });
    }
}
